module.exports = __webpack_public_path__ + "static/media/Logo.798e6611.png";